<template>
<!-- 生态宜居·二级轮播图 -->
  <div style="width: 100%;">
    <div class="swiper-container-wrapper">
      <!-- Slider main container -->
      <div class="swiper-container gallery-top" style="height:550px;">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
          <!-- Slides -->
          <div
            class="swiper-slide"
            v-for="(item, index) in VideoList"
            :key="index" 
          >
            <video
              :src="item.trailerUrl"
              style="width: 100%; height: 100%"
              controls
              controlslist="nodownload noremoteplayback"
             :disablePictureInPicture="true"
              :id="'my_player' + index"
            >
            </video>
             <div class="videoTxt" style="top:0; height:40px; line-height:40px; font-size:18px;">
              {{item.trailerName}}
            </div>
          </div>
        </div>
        <!-- Add Arrows -->
        <!-- <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div> -->
      </div>
      <!-- Slider thumbnail container -->
      <div class="swiper-container gallery-thumbs" style="height: 550px">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
          <!-- Slides -->
          <div
            class="swiper-slide"
            v-for="(item, index) in VideoList"
            :key="index">
            <video
              :src="item.trailerUrl"
              style="width: 100%; height: 100%"
            >
            </video>
            <div class="videoTxt">
              {{item.trailerName}}
            </div>
          </div>
        </div>
      </div>
    </div>
     <p class="text-center">视频来源：{{Data_txt}}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      VideoList: [],
      Data_txt:''
    };
  },
  methods: {
    getTrailerList() {
      this.VideoList = plOtherDataInterface.getTrailerList();
    },
    swiper() {
      var galleryThumbs = new Swiper(".gallery-thumbs", {
        observer: true,
        direction: "horizontal",
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        mousewheel: true,
        breakpoints: {
          480: {
            direction: "vertical",
            slidesPerView: 3,
          },
        },
        on: {
          click: () => {
            if (this.VideoList.length > 0) {
              this.VideoList.forEach((item, index) => {
                document.getElementById("my_player" + index).pause();
              });
            }
          },
        },
      });
      var galleryTop = new Swiper(".gallery-top", {
        observer: true,
        direction: "horizontal",
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          click: () => {
            if (this.VideoList.length > 0) {
              this.VideoList.forEach((item, index) => {
                document.getElementById("my_player" + index).pause();
              });
            }
          },
        },
        thumbs: {
          swiper: galleryThumbs,
        },
      });
    },
    // 数据来源
    Sources(){
      var dataSources = this.$json;
      this.Data_txt = dataSources.data[3].promotionalVideo;
    }
  },
  mounted() {
    this.swiper();
    this.getTrailerList();
    this.Sources()
  },
};
</script>

<style lang="less" scope>
@import url("../../../static/swiper/css/style.css");
@import url("../../../static/swiper/css/swiper-bundle.min.css");
video {
  object-fit: fill;
}
.videoTxt {
  width: 100%;
  height: 30px;
  position: absolute;
  bottom: 0;
  background: url("../../../static/image/videoTxt.png") no-repeat;
  background-size: 100% 100%;
  padding: 0 10px;
  box-sizing: border-box;
  font-size: 14px;
  text-align: left;
  color: #ffffff;
  margin: 0;
  line-height: 30px;
  z-index: 10;
}
.swiper_wrapper{
  height: 650px;
}
.text-center {
  margin-top: 15px;
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper/swiper.vue